import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { CardAvatar } from "@parkschannel/ui";
import { NextAvatar } from "../../NextAvatar";
import classNames from "classnames";
export const ProfileAvatar = (param)=>{
    let { src , children  } = param;
    return /*#__PURE__*/ _jsxs(CardAvatar, {
        size: "2xl",
        children: [
            /*#__PURE__*/ _jsx(NextAvatar, {
                src: src,
                size: "2xl",
                className: classNames("lg:w-[168px] lg:h-[168px] drop-shadow-xl")
            }),
            children
        ]
    });
};
